"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const brandedgift = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 52 60",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-brandedgift` : '') + (description ? ` desc-brandedgift` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-brandedgift"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-brandedgift"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.39 11a18.35 18.35 0 0 0-4.33-3.91 1.95 1.95 0 0 0-2.62.8c-.5.93-.15 2.1.8 2.6a18.54 18.54 0 0 0 6.85 1.43c-.2-.29-.43-.6-.7-.92Zm1.55 2.51-.01-.05v.05Zm.9-1.77a.22.22 0 0 1 .06-.02l-.05.02Zm2.92 2.64c1.57-2.92-4.85-9.34-7.78-10.88a6.06 6.06 0 0 0-8.14 2.49 5.94 5.94 0 0 0 2.47 8.08c2.93 1.55 11.89 3.23 13.45.3Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.61 11c1.56-1.9 3.5-3.47 4.33-3.91.94-.5 2.12-.14 2.62.8.5.93.15 2.1-.8 2.6a18.55 18.55 0 0 1-6.85 1.43c.2-.29.43-.6.7-.92Zm-1.55 2.51.01-.05a.19.19 0 0 0 0 .05Zm-.9-1.77a.21.21 0 0 0-.06-.02l.05.02Zm-2.92 2.64c-1.57-2.92 4.85-9.34 7.78-10.88a6.06 6.06 0 0 1 8.14 2.49 5.94 5.94 0 0 1-2.47 8.08c-2.93 1.55-11.89 3.23-13.45.3Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 25.27h48V55.7a3.64 3.64 0 0 1-3.7 3.57H5.7c-2.05 0-3.7-1.6-3.7-3.57V25.27Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0 15.27c0-1.1.83-2 1.86-2h48.28c1.03 0 1.86.9 1.86 2v8c0 1.1-.83 2-1.86 2H1.86c-1.03 0-1.86-.9-1.86-2v-8Z",
    fill: "#F8985A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M50.3 25.27H38.7L43 19.8l4.5-6.53h2.8c1.28 0 1.7 1 1.7 2v8c0 .5-.38 2-1.7 2Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.5 59.27c-5.5 0-6.5.5-8.5-2.5 25.5-16.57 36.7-31.5 36.7-31.5H50v30c0 4-4 4-4 4H10.5Z",
    fill: "#F26B1C"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M2 25.27h48v2H2v-2Z",
    fill: "#E35200"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 13.27h14v12H19v-12Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 27.27h14v32H19v-32Z",
    fill: "#E90B5A"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 59.27V44.4l14-12.63v27.5H19Z",
    fill: "#CC0058"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19 25.27h14v2H19v-2Z",
    fill: "#CC0058"
  }));
};
var _default = exports.default = brandedgift;